module.exports = __webpack_public_path__ + "img/slide6.55fc3d2b.png";